<!-- FEATURES SECTION -->
<!-- FULL WIDTH - 2 COLUMNS - TEXT RIGHT -->
<!-- FULL WIDTH - 2 COLUMNS - TEXT RIGHT -->

<div class="content-block-wrap {{ slice.primary?.class_name }}" [ngStyle]="getContainerBlockStyles(slice)"
  [attr.aria-label]="getAria(slice)">
  <!-- <section class="view"> -->
  <section>
    <div class="row d-flex align-items-stretch" [ngStyle]="getSectionBlockStyles(slice)">
      <div *ngIf="slice.primary?.background_image" class="mask flex-center"
        [ngClass]="{ 'rgba-black-strong': slice.primary?.overlay_tint == 'dark', 'rgba-white-light': slice.primary?.overlay_tint == 'light' }">
      </div>

      <div *ngFor="let feature of slice.fields; let i = index"
        class="col-md col-12 content-feature {{feature.content_block?.class_name}}"
        [ngClass]="{ 'content-feature-top-padding': feature.content_block?.mobile_height, 'countdown-timer': (feature.content_block?.body && feature.content_block?.body[0]?.type) == 'countdown_timer'}"
        [ngStyle]="getContentBlockStyles(feature)">
        <!-- Background Color -->
        <div *ngIf="feature.content_block?.background_image" class="mask desktop"
          [ngClass]="{ 'rgba-black-strong': feature.content_block?.overlay_tint == 'dark', 'rgba-white-light': feature.content_block?.overlay_tint == 'light' }">
        </div>

        <div *ngFor="let component of feature.content_block?.body; let i = index" [ngClass]="{  }">

          <div [ngClass]="{'cb-text': component.type !== 'image', 'mobile-margin': (component.type !== 'countdown_timer' && component.type !== 'image_carousel' && component.type !== 'vehicle' && component.type !== 'disclaimer') }">
            @switch (component.type) {
              @case ('countdown_timer') {
                <app-countdown-timer [component]="component"
                  [vehicleObject]="vehicle"></app-countdown-timer>
              }
              @case ('service_drive') {
                <app-service-drive [component]="component"
                  [vehicleObject]="vehicle"></app-service-drive>
              }
              @case ('user_info_modal') {
                <app-user-info [component]="component"></app-user-info>
              }
              @case ('image_carousel') {
                <app-image-carousel [component]="component"
                  [vehicleObject]="vehicle"></app-image-carousel>
              }
              @case ('title') {
                <app-component-title [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-title>
              }
              @case ('icon_group') {
                <app-component-icon-group [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-icon-group>
              }
              @case ('icon') {
                <app-component-icon [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-icon>
              }
              @case ('text') {
                <app-component-text [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-text>
              }
              @case ('grid') {
                <app-component-table [component]="component" [vehicleObject]="vehicle"
                  [max_width]="feature.content_block.width_percent"
                  [position]="feature.content_block.position"></app-component-table>
              }
              @case ('info_carousel') {
                <app-component-info-carousel [component]="component"
                  [vehicleObject]="vehicle" [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-info-carousel>
              }
              @case ('cta') {
                <app-component-cta [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color" [text_align]="feature.content_block.text_alignment"
                  (emitOpenModal)="openModal($event)"></app-component-cta>
              }
              @case ('image') {
                <app-component-image [component]="component"
                  [vehicleObject]="vehicle"></app-component-image>
              }
              @case ('icon_with_cta') {
                <app-component-icon-with-cta [component]="component"
                  [vehicleObject]="vehicle"></app-component-icon-with-cta>
              }
              @case ('video') {
                <app-component-video [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-video>
              }
              @case ('vehicle') {
                @if (!showMobile) {
                  <app-component-vehicle class="desktop app-component-vehicle"
                    [component]="component" [vehicleObject]="vehicle" [text_color]="feature.content_block.text_color"
                    [text_align]="feature.content_block.text_alignment"></app-component-vehicle>
                }
                @if (showMobile) {
                  @if (!component.primary?.stick_to_bottom_for_mobile) {
                    <app-component-vehicle
                      class="mobile app-component-vehicle" [component]="component" [vehicleObject]="vehicle"
                      [text_color]="feature.content_block.text_color"
                      [text_align]="feature.content_block.text_alignment"></app-component-vehicle>
                  }
                }
              }
              @case ('disclaimer') {
                <app-disclaimer [component]="component" [vehicleObject]="vehicle"
                  [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-disclaimer>
              }
            }
          </div>
        </div>
      </div>

      <div *ngFor="let feature of slice.fields" class="mobile full-width" [ngClass]="'col-md col-12'">
        <!-- Background Color -->

        <div *ngFor="let component of feature.content_block?.body">
          @switch (component.type) {
            @case ('vehicle') {
              @if (component.primary?.stick_to_bottom_for_mobile && showMobile) {
                <app-component-vehicle
                  [component]="component" [vehicleObject]="vehicle" [text_color]="feature.content_block.text_color"
                  [text_align]="feature.content_block.text_alignment"></app-component-vehicle>
              }
            }
          }
        </div>
      </div>
    </div>
  </section>
</div>

<!-- <pre>{{slice.primary | json}}</pre> -->